module.exports = __webpack_public_path__ + "img/dummy4.bc6205db.jpg";